import { ApiRequest, useAppSelector } from 'store/store';
import { GetSearchResponse, SearchMetaPageDataDto } from 'services/ApiService/SgmSearch/SgmSearchApiClient';
import { useParams } from 'react-router';
import { RouteParams } from 'routes/RoutePaths';

const getResultsOrEmpty = <T>(results: Nullable<ApiRequest<IPaginatedSgmSearchResults<T> | undefined>>): Required<ApiRequest<Required<IPaginatedSgmSearchResults<T>>>> => {
    return {
        state: results?.state || 'neverFetched',
        data: {
            items: [],
            searchMetaPageData: {
                page: 0,
                pageSizeBySearchType: 0,
                isFirstPage: false,
                isLastPage: false,
                totalCount: 0,
                totalPage: 0,
            },
            ...(results?.data || {}),
        },
    };
};

export type RequiredGetSearchResponse = Required<GetSearchResponse> & {
    [P in keyof GetSearchResponse]: Required<GetSearchResponse[P]>
}

export interface IPaginatedSgmSearchResults<T> {
    items?: T[]
    searchMetaPageData?: SearchMetaPageDataDto
}

type UseSearchItemResultsResponse = { searchTerm: string } & {
    [P in keyof Omit<RequiredGetSearchResponse, 'meta'>]: Required<ApiRequest<RequiredGetSearchResponse[P]>>
}

export const useSearchItemResults = (): UseSearchItemResultsResponse => {
    const { searchTerm: urlSearchTerm } = useParams<keyof RouteParams['Search']>();
    const { sgm, sg, person, company, searchTerm: reduxSearchTerm } = useAppSelector((state) => state.search);
    const searchTerm = reduxSearchTerm || urlSearchTerm || '';
    return {
        searchTerm,
        sgm: getResultsOrEmpty(sgm),
        sg: getResultsOrEmpty(sg),
        person: getResultsOrEmpty(person),
        company: getResultsOrEmpty(company),
    };
};